import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListingBuyerAlertCollectionDataProvider } from '@steelbuy/data-provider';

import { useVendorComponent } from '@steelbuy/vendor';
import { useSearchFormDataContext } from '../../components/listing-search/SearchFormDataContext';
import { RoutePath } from '../../router/Routes';

export const SearchListingsResultsView = () => {
    const navigate = useNavigate();
    const searchFormData = useSearchFormDataContext().getSearchFormData();
    const SearchResults = useVendorComponent('searchResults');

    useEffect(() => {
        if (searchFormData === undefined) {
            navigate(RoutePath.SEARCH_LISTINGS);
        }
    });

    return (
        <ListingBuyerAlertCollectionDataProvider lazyLoad>
            <SearchResults />
        </ListingBuyerAlertCollectionDataProvider>
    );
};
